import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=5018e57a&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=5018e57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5018e57a",
  null
  
)

export default component.exports